/**
 * transposes number over bounds
 *
 * ### examples:
 * ```
 * (24, 0, 23) -> 0
 * (-1, 0, 23) -> 23
 * ```
 */
export function wrapIn(input: number, min: number = Number.MIN_SAFE_INTEGER, max: number = Number.MAX_SAFE_INTEGER): number {
  if (input < min || input > max) {
    const range = max - min + 1
    let r = input

    if (input > max) {
      while (r > max) {
        r -= range
      }
      return r
    }

    while (r < min) {
      r += range
    }
    return r
  }
  return input
}
